<template>
  <nav class="navbar-premium" :class="{ 'navbar-scrolled': isScrolled }">
    <div class="navbar-inner">
      <!-- Logo Section -->
      <div class="navbar-brand-section">
        <a @click="goToProperties" class="navbar-brand">
          <div v-if="logo" class="brand-logo">
            <img :src="logo" alt="Logo" />
          </div>
          <div v-else class="brand-placeholder">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <path
                d="M3 9.5L12 4L21 9.5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19 13V19.4C19 19.7314 18.7314 20 18.4 20H5.6C5.26863 20 5 19.7314 5 19.4V13"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </a>
      </div>

      <!-- Desktop Navigation -->
      <div class="navbar-navigation" :class="{ 'is-active': mobileMenuOpen }">
        <div class="nav-links">
          <a
            @click="goToProperties"
            class="nav-item"
            :class="{
              'is-active':
                $route.name === 'index' || $route.name === 'asset-detail',
            }"
          >
            <div class="nav-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 9.5L12 4L21 9.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 13V19.4C19 19.7314 18.7314 20 18.4 20H5.6C5.26863 20 5 19.7314 5 19.4V13"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span class="nav-label">{{
              customer === "clab" ? "Mis inversiones" : "Mis Propiedades"
            }}</span>
          </a>

          <router-link
            v-if="opportunitiesPermission"
            :to="{ name: 'opportunities' }"
            class="nav-item"
            :class="{ 'is-active': $route.name === 'opportunities' }"
            @click.native="scrollToTop"
          >
            <div class="nav-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M16 8L18.29 10.29C18.68 10.68 18.68 11.31 18.29 11.7L13.7 16.29C13.31 16.68 12.68 16.68 12.29 16.29L9.7 13.7C9.31 13.31 8.68 13.31 8.29 13.7L3 19"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21 12V4H13"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span class="nav-label">Oportunidades</span>
          </router-link>

          <router-link
            v-if="country == 1 && showQuote"
            :to="{ name: 'quote' }"
            class="nav-item"
            :class="{ 'is-active': $route.name === 'quote' }"
            @click.native="scrollToTop"
          >
            <div class="nav-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 5V19M5 12H19"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span class="nav-label">{{
              customer === "clab" ? "Simular" : "Cotizar"
            }}</span>
          </router-link>

          <router-link
            v-if="country == 1 && showQuotes"
            :to="{ name: 'myquotes' }"
            class="nav-item"
            :class="{ 'is-active': $route.name === 'myquotes' }"
            @click.native="scrollToTop"
          >
            <div class="nav-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7H11C9.89543 7 9 6.10457 9 5Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <path
                  d="M9 12H15M9 16H12"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <span class="nav-label">{{
              customer === "clab" ? "Simulaciones" : "Cotizaciones"
            }}</span>
          </router-link>

          <router-link
            v-if="showMyData"
            :to="{ name: 'information' }"
            class="nav-item"
            :class="{ 'is-active': $route.name === 'information' }"
            @click.native="scrollToTop"
          >
            <div class="nav-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="8"
                  r="4"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <path
                  d="M5 20C5 16.6863 7.68629 14 11 14H13C16.3137 14 19 16.6863 19 20"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <span class="nav-label">Mi Perfil</span>
          </router-link>
        </div>

        <!-- User Section -->
        <div class="nav-user-section">
          <div class="nav-separator"></div>

          <!-- Settings Dropdown -->
          <!-- Oculto temporalmente - Solo se usará diseño clásico -->
          <div class="settings-dropdown" v-if="false">
            <button
              class="settings-btn"
              title="Configuración"
              @click="toggleSettingsMenu"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <path
                  d="M19.6224 10.3954L18.5247 7.7448L20 6L18 4L16.2647 5.48295L13.5578 4.36974L12.9353 2H10.981L10.3491 4.40113L7.70441 5.51596L6 4L4 6L5.45337 7.78885L4.3725 10.4463L2 11V13L4.40111 13.6555L5.51575 16.2997L4 18L6 20L7.79116 18.5403L10.397 19.6123L11 22H13L13.6045 19.6132L16.2551 18.5155C16.6969 18.8313 18 20 18 20L20 18L18.5159 16.2494L19.6139 13.598L21.9999 12.9772L22 11L19.6224 10.3954Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <!-- Settings Menu -->
            <div class="settings-menu" v-if="settingsMenuOpen">
              <div class="settings-header">
                <span>Configuración</span>
              </div>
              <div class="settings-section">
                <span class="settings-label">Diseño del portal</span>
                <div class="layout-options">
                  <button
                    :class="[
                      'layout-option',
                      { active: layoutMode === 'classic' },
                    ]"
                    @click="changeLayout('classic')"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="3"
                        y="3"
                        width="18"
                        height="4"
                        rx="1"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <rect
                        x="3"
                        y="10"
                        width="18"
                        height="11"
                        rx="1"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                    </svg>
                    Clásico
                  </button>
                  <button
                    :class="[
                      'layout-option',
                      { active: layoutMode === 'modern' },
                    ]"
                    @click="changeLayout('modern')"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="3"
                        y="3"
                        width="5"
                        height="18"
                        rx="1"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <rect
                        x="11"
                        y="3"
                        width="10"
                        height="4"
                        rx="1"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <rect
                        x="11"
                        y="10"
                        width="10"
                        height="11"
                        rx="1"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                    </svg>
                    Moderno
                  </button>
                </div>
              </div>
            </div>
            <!-- Backdrop to close menu -->
            <div
              v-if="settingsMenuOpen"
              class="settings-backdrop"
              @click="settingsMenuOpen = false"
            ></div>
          </div>

          <div class="user-info" v-if="user">
            <div class="user-avatar">
              {{ user.name ? user.name.charAt(0).toUpperCase() : "U" }}
            </div>
            <div class="user-details">
              <span class="user-name">{{
                user.name ? user.name.split(" ")[0] : "Usuario"
              }}</span>
              <span class="user-role">Cliente</span>
            </div>
          </div>
          <button class="logout-btn" @click="logout" title="Cerrar sesión">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H15"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M11 12H4M4 12L7 9M4 12L7 15"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span class="logout-text">Salir</span>
          </button>
        </div>
      </div>

      <!-- Mobile Toggle -->
      <button
        class="mobile-toggle"
        @click="toggleMobileMenu"
        :class="{ 'is-open': mobileMenuOpen }"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- Mobile Backdrop -->
    <transition name="fade">
      <div
        v-if="mobileMenuOpen"
        class="mobile-backdrop"
        @click="closeMobileMenu"
      ></div>
    </transition>
  </nav>
</template>

<script>
export default {
  name: "NavBar",
  props: {
    layoutMode: { type: String, default: "classic" },
  },
  data() {
    return {
      mobileMenuOpen: false,
      isScrolled: false,
      user: this.$auth.user(),
      settingsMenuOpen: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 10;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      document.body.style.overflow = this.mobileMenuOpen ? "hidden" : "";
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      document.body.style.overflow = "";
    },
    toggleSettingsMenu() {
      this.settingsMenuOpen = !this.settingsMenuOpen;
    },
    changeLayout(mode) {
      this.$emit("change-layout", mode);
      this.settingsMenuOpen = false;
    },
    goToProperties() {
      this.closeMobileMenu();
      this.scrollToTop();
      // Emit event to go back to grid and navigate to index
      this.$root.$emit("go-back-to-grid");
      if (this.$route.name !== "index") {
        this.$router.push({ name: "index" });
      }
    },
    logout() {
      this.closeMobileMenu();
      this.$auth.logout({
        redirect: `/app/${this.$route.params.customer}/login`,
        success: function (msg) {
          console.error("LOGIN:", msg);
        },
      });
    },
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    logo() {
      if (this.$route.params.customer === "rimaza")
        return "/images/logo/rimaza.png";
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.logo_1_url
        : null;
    },
    country() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.country
        : 1;
    },
    opportunitiesPermission() {
      if (this.$store.getters.getCustomerData) {
        return this.$store.getters.getCustomerData.products.find(
          (product) => product.name == "Oportunidades"
        ) && this.$store.getters.getCustomerData.show_opportunity
          ? true
          : false;
      } else {
        return false;
      }
    },
    showQuote() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_quote
        : false;
    },
    showQuotes() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_quotes
        : false;
    },
    showMyData() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_my_data
        : false;
    },
  },
  watch: {
    $route() {
      this.closeMobileMenu();
    },
  },
};
</script>

<style scoped>
/* ===== Premium NavBar Styles ===== */
.navbar-premium {
  --nav-height: 70px;
  --nav-bg: var(--color-menu, #ffffff);
  --nav-text: var(--color-menu-text, #374151);
  --nav-text-muted: var(--color-menu-text, #6b7280);
  --nav-accent: var(--color-menu-a, #3b82f6);
  --nav-border: rgba(0, 0, 0, 0.06);
  --nav-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.03);
  --nav-shadow-scrolled: 0 4px 16px rgba(0, 0, 0, 0.08);
  --transition-fast: 0.15s ease;
  --transition-normal: 0.25s ease;
  --radius: 10px;

  position: sticky;
  top: 0;
  z-index: 1000;
  background: var(--nav-bg);
  border-bottom: 1px solid var(--nav-border);
  box-shadow: var(--nav-shadow);
  transition: all var(--transition-normal);
  animation: navbarSlideDown 0.4s ease;
}

@keyframes navbarSlideDown {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.navbar-premium.navbar-scrolled {
  box-shadow: var(--nav-shadow-scrolled);
}

.navbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: var(--classic-container-width, 100%);
  max-width: var(--classic-container-max, 1400px);
  margin: 0 auto;
  padding: 0 var(--classic-container-pad-x, 24px);
  height: var(--nav-height);
  box-sizing: border-box;
}

/* ===== Brand Section ===== */
.navbar-brand-section {
  flex-shrink: 0;
  animation: brandFadeIn 0.5s ease 0.2s backwards;
}

@keyframes brandFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.navbar-brand {
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: transform var(--transition-fast);
  cursor: pointer;
}

.navbar-brand:hover {
  transform: scale(1.02);
}

.brand-logo {
  display: flex;
  align-items: center;
}

.brand-logo img {
  max-height: 40px;
  width: auto;
  object-fit: contain;
}

.brand-placeholder {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--nav-accent);
  border-radius: var(--radius);
  color: #ffffff;
}

/* ===== Navigation Links ===== */
.navbar-navigation {
  display: flex;
  align-items: center;
  gap: 8px;
  animation: navLinksFadeIn 0.4s ease 0.3s backwards;
}

@keyframes navLinksFadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 4px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  color: var(--nav-text-muted);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: var(--radius);
  transition: all var(--transition-fast);
  position: relative;
}

.nav-item:hover {
  color: var(--nav-text);
  background: rgba(0, 0, 0, 0.04);
  text-decoration: none;
}

.nav-item.is-active {
  color: var(--nav-text);
  background: rgba(0, 0, 0, 0.06);
  font-weight: 600;
}

.nav-item.is-active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 20px);
  height: 2px;
  background: var(--nav-accent, #3b82f6);
  border-radius: 2px 2px 0 0;
}

.nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  transition: opacity var(--transition-fast);
}

.nav-item:hover .nav-icon,
.nav-item.is-active .nav-icon {
  opacity: 1;
}

.nav-label {
  white-space: nowrap;
}

/* ===== User Section ===== */
.nav-user-section {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: 8px;
  animation: userSectionFadeIn 0.4s ease 0.4s backwards;
}

@keyframes userSectionFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.nav-separator {
  width: 1px;
  height: 32px;
  background: var(--nav-text-muted);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid var(--nav-text);
  color: var(--nav-text);
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 50%;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--nav-text);
  line-height: 1.2;
}

.user-role {
  font-size: 0.75rem;
  color: var(--nav-text-muted);
  line-height: 1.2;
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: transparent;
  border: 1px solid var(--nav-text-muted);
  border-radius: var(--radius);
  color: var(--nav-text-muted);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.logout-btn:hover {
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.3);
  background: rgba(239, 68, 68, 0.06);
}

.logout-text {
  display: none;
}

/* ===== Mobile Toggle ===== */
.mobile-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
  gap: 5px;
}

.mobile-toggle span {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--nav-text);
  border-radius: 2px;
  transition: all var(--transition-fast);
}

.mobile-toggle.is-open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.mobile-toggle.is-open span:nth-child(2) {
  opacity: 0;
}

.mobile-toggle.is-open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* ===== Mobile Backdrop ===== */
.mobile-backdrop {
  display: none;
}

/* ===== Transitions ===== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity var(--transition-normal);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ===== Responsive - Tablet ===== */
@media (max-width: 1200px) {
  .nav-label {
    display: none;
  }

  .nav-item {
    padding: 10px 12px;
  }

  .user-details {
    display: none;
  }
}

/* ===== Responsive - Mobile ===== */
@media (max-width: 768px) {
  .navbar-inner {
    padding: 0 16px;
    height: 64px;
  }

  .mobile-toggle {
    display: flex;
  }

  .navbar-navigation {
    position: fixed;
    top: 64px;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: stretch;
    padding: 20px;
    background: var(--nav-bg);
    border-top: 1px solid var(--nav-border);
    box-shadow: var(--nav-shadow-scrolled);
    transform: translateY(-20px);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: all var(--transition-normal);
    max-height: calc(100vh - 64px);
    overflow-y: auto;
  }

  .navbar-navigation.is-active {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }

  .nav-links {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
  }

  .nav-item {
    padding: 14px 16px;
    border-radius: var(--radius);
  }

  .nav-label {
    display: inline;
  }

  .nav-item.is-active {
    background: rgba(59, 130, 246, 0.1);
  }

  .nav-user-section {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-left: 0;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--nav-border);
  }

  .nav-separator {
    display: none;
  }

  .user-info {
    padding: 12px 16px;
    background: rgba(0, 0, 0, 0.02);
    border-radius: var(--radius);
  }

  .user-details {
    display: flex;
  }

  .logout-btn {
    justify-content: center;
    padding: 14px 16px;
    background: rgba(239, 68, 68, 0.06);
    border-color: rgba(239, 68, 68, 0.2);
    color: #ef4444;
  }

  .logout-text {
    display: inline;
  }

  .mobile-backdrop {
    display: block;
    position: fixed;
    top: 64px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    z-index: -1;
  }
}

/* ===== Settings Dropdown ===== */
.settings-dropdown {
  position: relative;
}

.settings-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: transparent;
  border: 1px solid var(--nav-text-muted);
  border-radius: 10px;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.settings-btn:hover {
  background: var(--nav-text-muted);
  border-color: var(--nav-text-muted);
}

.settings-btn svg {
  width: 20px;
  height: 20px;
  color: var(--nav-text-muted);
  transition: transform 0.3s ease;
}

.settings-btn:hover svg {
  transform: rotate(45deg);
  color: #ffffff;
}

.settings-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 260px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: 8px 0;
  z-index: 1001;
  animation: fadeInDown 0.2s ease;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.settings-header {
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.settings-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.settings-section {
  padding: 12px 16px;
}

.settings-label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
}

.layout-options {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.layout-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  cursor: pointer;
  transition: all var(--transition-fast);
  width: 100%;
  text-align: left;
}

.layout-option:hover {
  background: rgba(59, 130, 246, 0.04);
  border-color: rgba(59, 130, 246, 0.2);
}

.layout-option.active {
  background: rgba(59, 130, 246, 0.08);
  border-color: var(--nav-accent);
}

.layout-option svg {
  width: 18px;
  height: 18px;
  color: var(--nav-text-muted);
  flex-shrink: 0;
}

.layout-option.active svg {
  color: var(--nav-accent);
}

.layout-option span {
  font-size: 13px;
  font-weight: 500;
  color: var(--nav-text);
}

.layout-option.active span {
  color: var(--nav-accent);
}

.settings-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}
</style>
